<!-- =========================================================================================
    File Name: TaskItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="mail__mail-item sm:px-4 pr-2 pt-6 pb-6" :class="{'mail__opened-mail': !task.unread}">

        <div class="flex w-full pl-4">
            <div class="flex w-full justify-between items-start">
                <div class="mail__details">
                    <div class="flex">
                      <div>
                        <h5 class="font-semibold">{{ task.TaskName }}</h5>
                      </div>
                    </div>
                    <div class="flex mt-1">
                      <div class="mr-2" v-if="task.CompleteDate == null">
                        <vs-button @click="BeginMarkComplete(task)" size="small" color="success" :disabled="(currentTaskID == task.TaskID && task.TaskID != null) || (currentSOWLineItemID == task.SOWLineItemID && task.SOWLineItemID != null)">Mark Completed</vs-button>
                      </div>
                      <div class="mr-2" v-if="task.CompleteDate == null">
                        <vs-button
                          @click="ClockInTask(task)" size="small" :disabled="(currentTaskID == task.TaskID && task.TaskID != null) || (currentSOWLineItemID == task.SOWLineItemID && task.SOWLineItemID != null)">
                          <span v-if="(currentTaskID == task.TaskID && task.TaskID != null) || (currentSOWLineItemID == task.SOWLineItemID && task.SOWLineItemID != null)">
                            Clocked In
                          </span>
                          <span v-else>
                            Clock In
                          </span>
                        </vs-button>
                      </div>
                      <div class="task-client theme-dark d-theme-dark-bg mr-2" v-if="client != null">
                        {{ client.ClientName }}
                      </div>
                      <div class="task-client theme-dark d-theme-dark-bg mr-2" v-if="task.CreateDate">
                        Created {{ FormatDate(task.CreateDate) }}
                      </div>
                      <div class="task-client theme-dark d-theme-dark-bg" v-if="task.CompleteDate">
                        Completed {{ FormatDate(task.CompleteDate) }}
                      </div>
                    </div>
                    
                    <div class="task-description">
                      {{ task.TaskNote }}
                    </div>

                    <!-- <div class="mt-3">
                      <div class="flex">
                        <vs-button :disabled="!CanClockIn" vs-type="flat" size="small" icon="timer" class="mr-2" @click="ClockIn()">Clock In</vs-button>
                        <vs-button icon="check" @click="BeginMarkComplete(task)" color="success" size="small">Mark Complete</vs-button>
                      </div>
                    </div> -->
                       <!-- <div style="width: 230px;"> 
                        <vs-progress :percent="GetBarPercent(task)" :color="GetBarColor(GetBarPercent(task))"></vs-progress>
                        <span>{{ task.fields.timespent.toFixed(1) }} out of {{task.fields.timeoriginalestimate.toFixed(1)}} hours</span>
                      </div> -->

                </div>

                <!-- <div class="mail-item__meta flex items-center">
                    <div class="email__labels hidden sm:flex items-center">
                        <div class="h-2 w-2 rounded-full mr-2" v-for="(label, index) in task.labels" :key="index"></div>
                    </div>

                    

                </div> -->
            </div>
        </div>

        <div class="w-full">
            <div class="flex items-center">
            </div>
            <div class="taskItemDetails">
                {{ task.TaskDetails }}
            </div>
            <!-- <div class="taskItemLink" v-if="task.DetailsURL != null">
              <vs-button color='success' type="border" icon="link" size="small" class="mt-2" @click="ViewDetails()">Details</vs-button>
            </div> -->
        </div>

        <vs-prompt
          title="Mark Task Complete"
          color="primary"
          :active.sync="completeModalOpen"
          @accept="FinishMarkTaskComplete"
        >
          <div>
            Mark task as completed?
          </div>
          <div>
            Further editing of the task will not be allowed.
          </div>
          <!-- <vs-textarea class="mt-2" height="10rem" label="Note"></vs-textarea>
          <vs-textarea class="mt-2" height="10rem" label="Description"></vs-textarea> -->

        </vs-prompt>

    </div>
</template>

<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const moment = require('moment') // require


export default {
  components:{
    flatPickr,
    'v-select': vSelect
  },
  props: {
    task: {
      type: Object,
      required: true
    },

    currentTask:null
  },
  data () {
    return {
      completeModalOpen: false,
      taskCompleting: null,
    }
  },
  watch: {
  },
  computed: {
    currentTimeEntry() {
      return this.$store.getters.GetCurrentTimeEntry
    },
    currentSOWLineItemID() {
      if (this.currentTimeEntry == null) {
        return null
      }
      return this.currentTimeEntry.SOWLineItemID
    },
    currentTaskID() {
      if (this.currentTimeEntry == null) {
        return null
      }
      return this.currentTimeEntry.TaskID
    },
    client() {
      return this.clientList.find(x => x.ClientID == this.task.ClientID)
    },
    sowList() {
      const sows = this.$store.getters.GetSOWList
      return sows
    },
    clientList() {
			return this.$store.getters.GetClientList
    },
    ProjectList () {
      return this.$store.getters.GetProjectList
    },
    CanClockIn () {
      if (this.currentTask == this.task) {
        return false
      } else {
        return true
      }
    },
    currentTimeEntry () {
      return this.$store.getters.GetCurrentTimeEntry
    }
    
  },
  methods: {
    ClockInTask(task) {
      const currentTime = moment().format('hh:mm A')
      const currentDate = moment().format('Y-MM-DD')

      this.$store.dispatch('ActionSetTimeEntryPrompt', {
        active: true,
        title: 'Clock In',
        // taskName: null,
        taskID: task.TaskID,
        itatTaskID: task.TaskID,
        // clientName: 'ITAT Internal',
        clientID: task.ClientID,
        categoryID: task.CategoryID,
        // clientCategory: 'Client Category',
        startTime: currentTime,
        startDate: currentDate,
        endTime: null,
        endDate: null,
        description: `${task.TaskName} - ${task.TaskNote}`,
        error: 'Fields cannot be empty.',
        action: 'create', //create, clockin, finish
        mileage: 0,
        sowID: task.SOWID,
        sowLineItemID: task.SOWLineItemID,
      })
    },
    FormatDate(date) {
      return moment(date).format('M/DD/YYYY')
    },
    BeginMarkComplete(task) {
      console.log('completing task', task)
      this.taskCompleting = task
      this.completeModalOpen = true
    },
    FinishMarkTaskComplete() {
      this.$store.dispatch('ActionMarkTaskComplete', {
        taskId: this.taskCompleting.TaskID
      })
    },
    GetTaskContent (task) {
      if (task.fields.description == null) return ''

      return task.fields.description.content.reduce(function (total, item) {
        if (item.type == 'paragraph') {
          let add = ''
          for (let i = 0; i < item.content.length; i++) {
            if (item.content[i].type == 'text') {
              add += item.content[i].text
            }
          }
          return total + add

        } else {
          return total
        }
      }, '')
    },
    ViewDetails () {
      window.open(`https://${  this.$store.getters.GetJiraDomain  }.atlassian.net/browse/${  this.task.key}`, '_blank')
    },
    GetBarPercent (task) {
      const r = task.fields.timespent / task.fields.timeoriginalestimate * 100
      return r
    },
    GetBarColor (percent) {
      if (percent <= 80) {
        return 'success'
      } else if (percent <= 100) {
        return 'warning'
      }
      return 'danger'
    },
    GetProjectCategoryID (projectID) {
      var project = this.ProjectList.find(x => x.id.toString() == projectID.toString())
      if(project != null)
        return project.ITATInfo.CategoryID
      else
        return null
    },
    ClockIn () {
      if (this.currentTimeEntry == null) {
        const currentTime = moment().format('hh:mm A')
        const currentDate = moment().format('Y-MM-DD')

        const client = this.clientList.find(x => x.ClientID == this.task.ClientID)
        const clientId = client ? client.ClientID : null
        const clientName = client ? client.ClientName : null
        const sow = this.sowList.find(x => x.SOWID == this.task.SOWID)

        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Clock In',
          taskName: this.task.Task,
          jiraIssueID: this.task.id.toString(),
          clientName: clientName,
          clientID: clientId,
          projectID: this.task.fields.project.id,
          categoryID: sow.CategoryID,
          clientCategory: 'Client Category',
          startTime: currentTime,
          startDate: currentDate,
          task: this.task,
          endTime: null,
          endDate: null,
          description: '',
          error: 'Fields cannot be empty.',
          action: 'clockin', //create, clockin, finish
          mileage: 0,
          sowID: null,
          sowLineItemID: null,
        })
      } else {
        this.$emit('ChildClockIn', this.task)
      }
      
    }
  }
}

</script>


